module.exports = __webpack_public_path__ + "img/icons.5231a9af.svg";